module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allnav"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('transition', {
    attrs: {
      "name": "main-view-anim"
    }
  }, [_c('div', {
    staticClass: "subcontainer",
    attrs: {
      "id": "headline"
    }
  }, [_c('vue-typer', {
    attrs: {
      "text": ["Paul Gowder"],
      "caret-animation": "blink",
      "erase-style": "select-all",
      "erase-on-complete": false,
      "pre-type-delay": 0,
      "type-delay": 350,
      "erase-delay": 400,
      "repeat": 0
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "bigcontainer"
  }, [_c('div', {
    staticClass: "bigsubcontainer"
  }, [_c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "user-secret",
      "word": "bio",
      "toggle": "bio"
    }
  }), _vm._v(" "), _c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "flask",
      "word": "research",
      "toggle": "pubs"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bigsubcontainer"
  }, [_c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "list-ul",
      "word": "cv",
      "toggle": "cv"
    }
  }), _vm._v(" "), _c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "code",
      "word": "tech",
      "toggle": "tech"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bigsubcontainer"
  }, [_c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "pencil",
      "word": "external",
      "toggle": "writing"
    }
  }), _vm._v(" "), _c('bigicon', {
    staticClass: "navicon",
    attrs: {
      "icon": "address-card",
      "word": "contact",
      "toggle": "contact"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b928ebd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/bignavbar.vue
// module id = 203
// module chunks = 0